import styled from "styled-components";

export const Section = styled.section`
min-height:70vh;
margin-bottom:5em;
font-family: "Montserrat", sans-serif;

`;

